import React, { useEffect, useMemo, useState } from "react";
import api from "../lib/api";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Input } from "../components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { OverviewTab } from "../components/analytics/OverviewTab";
import { RankingTab } from "../components/analytics/RankingTab";
import { VendorsTab, IncomeTab } from "../components/analytics/FinanceTabs";
import { BalanceTab } from "../components/analytics/BalanceTab";

const pad = (n) => String(n).padStart(2, "0");
const monthBounds = () => {
  const d = new Date();
  const last = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
  return [`${d.getFullYear()}-${pad(d.getMonth() + 1)}-01`, `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(last)}`];
};
const RANGED = ["overview", "clients", "products", "vendors"];

export default function Analytics() {
  const [b0, b1] = monthBounds();
  const [from, setFrom] = useState(b0);
  const [to, setTo] = useState(b1);
  const [vendor, setVendor] = useState("");
  const [sellers, setSellers] = useState([]);
  const [tab, setTab] = useState("overview");
  useEffect(() => { api.get("/clients/sellers").then((r) => setSellers(r.data)).catch(() => {}); }, []);
  const params = useMemo(() => ({ date_from: from, date_to: to, ...(vendor ? { vendor } : {}) }), [from, to, vendor]);

  return (
    <div className="space-y-5" data-testid="analytics-page">
      <Tabs value={tab} onValueChange={setTab}>
        <div className="flex flex-col gap-3">
          <TabsList className="rounded-sm h-auto flex-wrap justify-start w-full sm:w-fit" data-testid="analytics-tabs">
            <TabsTrigger value="overview" className="rounded-sm" data-testid="tab-overview">Resumen</TabsTrigger>
            <TabsTrigger value="clients" className="rounded-sm" data-testid="tab-clients">Clientes</TabsTrigger>
            <TabsTrigger value="products" className="rounded-sm" data-testid="tab-products">Productos</TabsTrigger>
            <TabsTrigger value="vendors" className="rounded-sm" data-testid="tab-vendors">Vendedores</TabsTrigger>
            <TabsTrigger value="income" className="rounded-sm" data-testid="tab-income">Estado de resultados</TabsTrigger>
            <TabsTrigger value="balance" className="rounded-sm" data-testid="tab-balance">Balance general</TabsTrigger>
          </TabsList>
          {RANGED.includes(tab) && (
            <div className="flex flex-wrap items-end gap-2" data-testid="analytics-filters">
              <label className="text-[11px] font-bold uppercase tracking-widest text-muted-foreground">Desde<Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="rounded-sm h-9 w-40 mt-1" data-testid="analytics-from" /></label>
              <label className="text-[11px] font-bold uppercase tracking-widest text-muted-foreground">Hasta<Input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="rounded-sm h-9 w-40 mt-1" data-testid="analytics-to" /></label>
              {tab !== "vendors" && (
                <Select value={vendor || "all"} onValueChange={(v) => setVendor(v === "all" ? "" : v)}>
                  <SelectTrigger className="rounded-sm w-56 h-9" data-testid="analytics-vendor"><SelectValue /></SelectTrigger>
                  <SelectContent><SelectItem value="all">Todos los vendedores</SelectItem>{sellers.map((s) => <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>)}</SelectContent>
                </Select>)}
            </div>)}
        </div>
        <TabsContent value="overview" className="mt-4"><OverviewTab params={params} /></TabsContent>
        <TabsContent value="clients" className="mt-4"><RankingTab kind="clients" params={params} /></TabsContent>
        <TabsContent value="products" className="mt-4"><RankingTab kind="products" params={params} /></TabsContent>
        <TabsContent value="vendors" className="mt-4"><VendorsTab params={params} /></TabsContent>
        <TabsContent value="income" className="mt-4"><IncomeTab /></TabsContent>
        <TabsContent value="balance" className="mt-4"><BalanceTab /></TabsContent>
      </Tabs>
    </div>
  );
}
